<template>
	<div>
		<div class="filter-inline-panel cle">
			<el-form :inline="true" size="mini" :model="pages" class="filter-panel" :class="lang=='cn'?'':'on'">
				<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
					<el-cascader v-model="pages.cate" clearable class="w100" :props="props_" :options="cateOption"></el-cascader>
				</el-form-item>
				<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
					<el-date-picker v-model="pages.date" clearable value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
				</el-form-item>
				<el-form-item :label="$t('course_index.year')" prop="date" data-name="年度">
					<el-date-picker v-model="pages.year" type="year" value-format="yyyy" :placeholder="$t('index.select')"></el-date-picker>
				</el-form-item>
				<el-form-item :label="$t('course_index.age')" prop="age" data-name="年龄">
					<el-select v-model="pages.age" class="w100" clearable :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in age" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.session')" prop="session" data-name="学期">
					<el-select v-model="pages.session" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.week')" prop="week" data-name="星期">
					<el-select v-model="pages.week" clearable class="w100" :placeholder="$t('index.pleaseInput')">
						<el-option v-for="(item,index) in WEEK_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.center')" prop="center_id" data-name="学习中心">
					<el-select v-model="pages.center_id" clearable class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in learnCenter" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id"  v-if="item.course_type==0||item.course_type==1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
					<el-select v-model="pages.teacher_id" filterable clearable class="w100" :placeholder="$t('index.select')">
						<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.teacher_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('course_index.theme')" prop="keyword" data-name="主题">
					<el-input v-model="pages.keyword" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item label="ID" prop="ID" data-name="id">
					<el-input v-model="pages.id" :placeholder="$t('index.pleaseInput')"></el-input>
				</el-form-item>
				<el-form-item data-name="试听">
					<el-checkbox v-model="pages.shiting" :true-label="1" :false-label="0">{{$t('parent_index.trial_listening')}}</el-checkbox>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="search()">{{$t('index.search')}}</el-button>
					<el-button type="primary" size="mini" @click="reset()">{{$t('index.reset')}}</el-button>
				</el-form-item>
			</el-form>
			<div class="list-opinion fr">
				<div style="margin-bottom:5px;">
					<el-button type="primary" size="mini" @click="add('')" v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
					<el-button type="primary" size="mini" @click="seller_id_ff('')" v-if="hasBtn('binding_administrator')">{{$t('course_index.binding_seller')}}</el-button>
				</div>
				<el-button type="primary" size="mini" @click="importtemplate('')">{{$t('index.importtemplate')}}</el-button>
				<el-upload class="upload_" :action="API_UP+'courseImport'" name="excel" :data="{TokenId:TokenId}" :show-file-list="false" :before-upload="before_upload"  :on-success="function(res, file){imageSuccess(res, file,'image')} ">
					<el-button size="mini" type="primary">{{$t('index.import')}}</el-button>
				</el-upload>
				<!-- <el-button type="primary" size="mini" @click="seller_id_ff('')" v-if="hasBtn('binding_administrator')">{{$t('index.import')}}</el-button> -->
				<!-- <el-button type="primary" size="mini" @click="ceshi('')">修改</el-button> -->
			</div>
		</div>
		<el-table :data="list" size="mini" border @selection-change="handleSelectionChange" @sort-change="sort_change">
			<el-table-column type="selection" width="40" align="center"></el-table-column>
			<el-table-column prop="id" align="center" label="ID" data-name="id" width="60"></el-table-column>
			<el-table-column :prop="lang=='cn'?'theme_cn':'theme'" align="center" :label="$t('course_index.theme')" data-name="主题" width="120">
				<template slot-scope="scope">
					<a target="_blank" class="clo3" :href="API_URL+'#/course_info?id='+scope.row.id">{{lang=='cn'?scope.row.theme_cn:scope.row.theme}}</a>
				</template>
			</el-table-column>
			<el-table-column prop="teacher_id" align="center" :label="$t('course_index.teacher')" data-name="老师">
				<template slot-scope="{row}">{{filters_list(row.teacher_id,teacher,'teacher_id','name')}}</template>
			</el-table-column>
			<el-table-column prop="start_date" align="center" :label="$t('course_index.date')" data-name="日期" width="100">
				<template slot-scope="{row}"><p>{{getTime_us(row.start_date,'mmddyyyy')}}</p><p>{{getTime_us(row.end_date,'mmddyyyy')}}</p></template>
			</el-table-column>
			<el-table-column prop="week" align="center" :label="$t('course_index.week')" data-name="星期">
				<template slot-scope="scope">{{getTime_week(scope.row.have_date_time)}}</template>
			</el-table-column>
			<el-table-column prop="start_time" align="center" :label="$t('course_index.time')" data-name="时间" width="90">
				<template slot-scope="{row}"><p>{{getTime_us(row.start_time,'hh:ii')}}</p> <p>{{getTime_us(row.end_time,'hh:ii')}}</p></template>
			</el-table-column>
			<el-table-column prop="session" align="center" :label="$t('course_index.session')" data-name="学期" width="130">
				<template slot-scope="{row}">{{getTime_us_f(row.have_date_time,'yyyy')}} {{filters_list(row.session,SESSION_ARR,'code','name')}}</template>
			</el-table-column>
			<el-table-column prop="surplus" align="center" :label="$t('course_index.max_people')" data-name="班级规模"  sortable="custom" width="110">
				<template slot-scope="{row}"><span style="color:#ff0000" v-if="row.remote_course_id">({{row.remote_student_num}})</span>{{row.student_num}}/{{row.max_people}}
				</template>
			</el-table-column>
			<el-table-column prop="age" align="center" :label="$t('course_index.age')" data-name="年龄" width="70">
				<template slot-scope="scope">{{scope.row.min_age}}-{{scope.row.max_age}}y</template>
			</el-table-column>
			<el-table-column prop="price" align="center" :label="$t('course_index.price')" data-name="学费"></el-table-column>
			<el-table-column prop="cate_id" align="center" :label="$t('course_index.cate')" :formatter="cate_id_f" data-name="分类" width="200">
				<template slot-scope="{row}"> {{filters_cate(row)}} </template>
			</el-table-column>
			<el-table-column prop="center_id" align="center" :label="$t('course_index.center')" data-name="学习中心" width="100">
				<template slot-scope="{row}">{{filters_list(row.center_id,learnCenter,'id','name')}}</template>
			</el-table-column>
			<el-table-column prop="class_num" align="center" :label="$t('course_index.class_num')" data-name="总课次" width="80"></el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('course_index.create_time')" data-name="时间">
				<template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
			</el-table-column>
			<el-table-column prop="remarks" align="center" :label="$t('feedback_index.remarks')" data-name="备注"></el-table-column>
			<el-table-column prop="create_time" align="center" :label="$t('course_index.status')" data-name="状态">
				<template slot-scope="scope">{{scope.row.status>1?$t('course_index.upcoming'):$t('course_index.ongoing')}}</template>
			</el-table-column>
			<el-table-column :label="$t('index.operation')" align="center" fixed="right" :width="lang=='cn'?290:330">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)" data-name="编辑">{{$t('index.edit')}}</el-button>
					<el-button size="mini" type="primary" v-if="hasBtn('Student_list')" @click="teacher_course_index_id=scope.row.id,isdialog=true" data-name="学生列表">{{$t('course_index.student_list')}}</el-button>
					<!-- <el-button size="mini" type="primary" v-if="hasBtn('copy')" @click.native="copy(scope.row,true)" data-name="复制">{{$t('index.copy')}}</el-button> -->
					<el-button size="mini" type="danger" v-if="hasBtn('status')&&scope.row.is_up==1" data-name="上线" @click="up(scope.row,0)">{{$t('course_index.up_0')}}</el-button>
					<el-button size="mini" type="success" v-if="hasBtn('status')&&scope.row.is_up==0" data-name="下线" @click="up(scope.row,1)">{{$t('course_index.up_1')}}</el-button>
					<el-dropdown @command="(e)=>{handleCommand(e,scope.row)}">
						<el-button size="mini">更多</el-button>
						<el-dropdown-menu slot="dropdown">
						    <el-dropdown-item command="a" data-name="隐藏" v-if="hasBtn('del')">{{$t('index.hide')}}</el-dropdown-item>
						    <el-dropdown-item command="b" data-name="删除" v-if="hasBtn('del')">{{$t('index.del')}}</el-dropdown-item>
						    <!-- <el-dropdown-item command="c" data-name="学生列表" v-if="hasBtn('Student_list')">{{$t('course_index.student_list')}}</el-dropdown-item> -->
						    <el-dropdown-item command="i" data-name="复制" v-if="hasBtn('copy')">{{$t('index.copy')}}</el-dropdown-item>
						    <el-dropdown-item command="d" data-name="课程安排" v-if="hasBtn('course_list')">{{$t('course_index.course_list')}}</el-dropdown-item>
						    <el-dropdown-item command="e" data-name="开课" v-if="hasBtn('class_starts')">{{$t('course_index.class_start')}}</el-dropdown-item>
						    <el-dropdown-item command="f" data-name="邮件记录" v-if="hasBtn('virtual')">{{$t('course_index.mail_record')}}</el-dropdown-item>
						    <el-dropdown-item command="j" data-name="虚拟班级" v-if="hasBtn('virtual')&&scope.row.status>1">{{$t('course_index.virtual')}}</el-dropdown-item>
						    <el-dropdown-item command="h" data-name="备注">{{$t('feedback_index.remarks')}}</el-dropdown-item>
						    <el-dropdown-item command="r" data-name="操作记录">{{$t('course_index.record')}}</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<pagination :total="pages.count" :page.sync="pages.page" :limit.sync="pages.perpage" @pagination="init" />
		<el-dialog :title="$t('index.dialog_title')" v-if="editFormVisible" :close-on-click-modal="false" :visible.sync="editFormVisible" width="1200px">
			<div class="dialog-header">
				<el-button size="mini" type="primary" class="fint_ma_top" @click.native="field_add">{{$t('course_index.add_field')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
			<el-form label-width="80px" ref="editForm" size="mini" label-position="top" :rules="editFormRules" :model="editForm">
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('index.cn')+$t('course_index.theme')" prop="theme_cn" data-name="主题">
							<el-input v-model="editForm.theme_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.en')+$t('course_index.theme')" prop="theme" data-name="主题">
							<el-input v-model="editForm.theme" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.cate')" prop="cate" data-name="分类">
							<el-cascader v-model="editForm.cate" class="w100" :props="props" :options="cateOption"></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="editForm.power_type=='protected'?3:6">
						<el-form-item :label="$t('course_index.power_type')" prop="power_type" data-name="状态">
							<el-select v-model="editForm.power_type" class="w100" :placeholder="$t('index.select')">
								<el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" :key="index" v-for="(item,index) in STATUS"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3" v-if="editForm.power_type=='protected'">
						<el-form-item :label="$t('course_index.password')" prop="password" data-name="密码">
							<el-input v-model="editForm.password " :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="4">
						<el-form-item :label="$t('course_index.price')" prop="price" data-name="价格">
							<el-input v-model="editForm.price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.noon_price')" prop="noon_price" data-name="午托金额">
							<el-input v-model="editForm.noon_price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.audition_price')" prop="audition_price" data-name="试听金额">
							<el-input v-model="editForm.audition_price" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.teacher')" prop="teacher_id" data-name="老师">
							<el-select v-model="editForm.teacher_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" v-if="item.type==1" :value="String(item.teacher_id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('parent_index.seller')" prop="course_seller_id" data-name="销售">
							<el-select v-model="editForm.course_seller_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in courseSellerList" :key="index" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.assistant')" prop="assistant_id" data-name="助教">
							<el-select v-model="editForm.assistant_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in teacher" :key="index" :label="lang=='cn'?item.name_cn:item.name" v-if="item.type==2" :value="parseFloat(item.teacher_id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="4">
						<el-form-item :label="$t('course_index.session')" prop="session" data-name="学期">
							<el-select v-model="editForm.session" class="w100" :placeholder="$t('index.pleaseInput')">
								<el-option v-for="(item,index) in SESSION_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.center')" prop="center_id" data-name="学习中心">
							<el-select v-model="editForm.center_id" class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in learnCenter" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.id" v-if="item.course_type==0||item.course_type==1" ></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.age')" data-name="年龄">
							<el-row class="tree-content" :gutter="0">
								<el-col :span="11">
									<el-input v-model="editForm.min_age" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-col>
								<el-col class="line" :span="2">-</el-col>
								<el-col :span="11">
									<el-input v-model="editForm.max_age" :placeholder="$t('index.pleaseInput')"></el-input>
								</el-col>
							</el-row>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.max_people')" prop="max_people" data-name="班级规模">
							<el-input v-model="editForm.max_people" type="Number" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.is_show_contact')" prop="is_show_contact" data-name="是否显示老师交流">
							<el-switch v-model="editForm.is_show_contact" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.is_show_evaluation')" prop="is_show_evaluation" data-name="是否显示评估表">
							<el-switch v-model="editForm.is_show_evaluation" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.hide')" :inactive-text="$t('course_index.show')"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="20">
					<el-col :span="6">
						<el-form-item :label="$t('course_index.date')" prop="date" data-name="日期">
							<el-date-picker v-model="editForm.date" class="w100" @change="class_num_f" value-format="timestamp" type="daterange" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.startdate')" :end-placeholder="$t('course_index.enddate')"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('course_index.time')" prop="time" data-name="时间">
							<el-time-picker v-model="editForm.time" class="w100" @change="class_num_f" value-format="timestamp" format="HH:mm" :range-separator="$t('course_index.range')" :start-placeholder="$t('course_index.starttime')" :end-placeholder="$t('course_index.endtime')" is-range></el-time-picker>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('course_index.week')" prop="week" data-name="星期">
							<el-select v-model="editForm.week" multiple class="w100" @change="class_num_f" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in WEEK_ARR" :key="index" :label="lang=='cn'?item.name_cn:item.name" :value="item.code"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.class_num')" prop="class_num" data-name="总课次">
							<el-input v-model="editForm.class_num" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="8">
						<el-form-item :label="$t('course_index.no_course_dates')" prop="no_course_dates" data-name="不上课日期">
							<el-date-picker type="dates" class="w100" v-model="editForm.no_course_dates" @change="class_num_f" value-format="timestamp" :placeholder="$t('index.select')"></el-date-picker>
						</el-form-item>
						<el-form-item :label="$t('course_index.remote_course_id')" prop="remote_course_id" data-name="关联课程">
							<el-input v-model="editForm.remote_course_id" clearable :placeholder="$t('index.select')">
								<el-button slot="append" icon="el-icon-search" @click="is_other_course=true"></el-button>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('course_index.administrators')" prop="seller_id" data-name="管理员">
							<el-select v-model="editForm.seller_id" multiple class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="String(item.id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item :label="$t('course_index.zoom')" prop="zoom" data-name="zoom链接">
							<el-input v-model="editForm.zoom" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{minRows:6,maxRows:6}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.send_leave_coupon')" prop="send_leave_coupon" data-name="请假是否发优惠券">
							<el-switch v-model="editForm.send_leave_coupon" active-color="#ff4949" :active-value="0" :inactive-value="1" inactive-color="#13ce66" :active-text="$t('course_index.no')" :inactive-text="$t('course_index.yes')"></el-switch>
						</el-form-item>
					</el-col>



				</el-row>
				<el-row  :gutter="10" v-for="(item,index) in editForm.course_field" :key="index">
					<el-col :span="6">
						<el-form-item :label="$t('course_index.field')" :prop="'course_field.'+index+'.code'" :rules="editFormRules.code" data-name="字段">
							<el-input  v-model="item.code" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.cn')+$t('course_index.field_name')" :prop="'course_field.'+index+'.name_cn'" :rules="editFormRules.name_cn" data-name="字段名">
							<el-input  v-model="item.name_cn" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item :label="$t('index.en')+$t('course_index.field_name')" :prop="'course_field.'+index+'.name'" :rules="editFormRules.name" data-name="字段名">
							<el-input  v-model="item.name" :placeholder="$t('index.pleaseInput')"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item :label="$t('course_index.is_must')" data-name="是否必填">
							<el-checkbox v-model="item.is_must" :true-label="1" :false-label="0">{{$t('course_index.required')}}</el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<i class="fint el-icon-remove" @click="field_del(index)"></i>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_index.introduce')" prop="introduce_cn" data-name="说明">
							<el-input v-model="editForm.introduce_cn" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 5, maxRows: 5}"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_index.introduce')" prop="introduce" data-name="说明">
							<el-input v-model="editForm.introduce" :placeholder="$t('index.pleaseInput')" type="textarea" :autosize="{ minRows: 5, maxRows: 5}"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="10">
					<el-col :span="12">
						<el-form-item :label="$t('index.cn')+$t('course_index.content')" prop="content_cn" data-name="课堂亮点">
							<editor-bar v-model="editForm.content_cn" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item :label="$t('index.en')+$t('course_index.content')" prop="content" data-name="课堂亮点">
							<editor-bar v-model="editForm.content" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" type="primary" class="fint_ma_top" @click.native="field_add">{{$t('course_index.add_field')}}</el-button>
				<el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
			</div>
			<!-- 关联美国课程 -->
			<el-dialog :title="$t('course_index.remote_course_id')" top="1vh" width="1300px" append-to-body :close-on-click-modal="false" :visible="is_other_course" @close="is_other_course = false">
				<courseRemoteList :remote_course_id="editForm.remote_course_id" @callback="(e)=>{editForm.remote_course_id=e,is_other_course=false}"></courseRemoteList>
			</el-dialog>
		</el-dialog>
		<teacher_student_list :isdialog="isdialog" :id="teacher_course_index_id" @guanbitanchu="function(e){isdialog=false}"></teacher_student_list>
		<!-- 选择邮件模板 -->
		<el-dialog :title="$t('course_index.xuanzyoujian')" :close-on-click-modal="false" :visible.sync="xuanzyoujian_is" width="500px">
			<el-form label-width="80px" ref="form" size="mini" label-position="top" :rules="editFormRules" :model="form">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="12">
						<el-form-item :label="$t('course_index.if_notice')" prop="if_notice" data-name="是否发送开课通知">
							<el-switch v-model="form.is_notice" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
						</el-form-item>
					</el-col>
					<span v-if="form.is_notice">
						<!-- <el-col :span="6">
							<el-form-item :label="$t('course_index.youjian_title')" prop="title" data-name="邮件标题">
								<el-input v-model="form.title" :placeholder="$t('index.pleaseInput')"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item :label="$t('course_index.xuanzyoujian')" prop="tmp_id" data-name="邮件">
								<el-select v-model="form.tmp_id" @change="tmp_id_f" class="w100" :placeholder="$t('index.select')">
									<el-option :label="item.title" :value="item.id" :key="index" v-for="(item,index) in tmplist"></el-option>
								</el-select>
							</el-form-item>
						</el-col> -->
						<el-col :span="6">
							<el-form-item :label="$t('course_index.mail_type')" prop="mail_type" data-name="发送类型">
								<el-select v-model="form.mail_type" class="w100" :placeholder="$t('index.select')">
									<el-option :label="lang=='cn'?item.cn:item.en" :value="item.id" :key="index" v-for="(item,index) in mail_type_list"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="24" v-if="form.mail_type==2">
							<el-form-item :label="$t('course_index.student_list')" prop="title" data-name="学生列表">
								<el-checkbox-group v-model="form.child_ids">
									<el-checkbox :label="item.child_id" v-for="(item,index) in student_list" :key="index"><el-badge :is-dot="!item.have_open_mail">{{item.name}}</el-badge></el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
					</span>
				</el-row>
				<!-- <el-row class="tree-content" :gutter="20" v-if="form.is_notice&&form.content">
					<el-col :span="24">
						<el-form-item :label="$t('course_index.xuanzyoujian')" prop="content" data-name="邮件">
				            <editor-bar v-model="form.content" :isClear="isClear"></editor-bar>
						</el-form-item>
					</el-col>
				</el-row> -->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="xuanzyoujian_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="xuanzyoujian_f('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 绑定管理员 -->
		<el-dialog :title="$t('course_index.administrators')" :close-on-click-modal="false" :visible.sync="seller_id_is" width="500px">
			<el-form label-width="80px" ref="form" size="mini" label-position="top" :rules="editFormRules" :model="form">
				<el-row class="tree-content" :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('course_index.administrators')" prop="seller_id" data-name="管理员">
							<el-select v-model="form.seller_id" multiple class="w100" :placeholder="$t('index.select')">
								<el-option v-for="(item,index) in sellerList" :key="index" :label="item.name" :value="String(item.id)"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="seller_id_is = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="seller_id_f('editForm')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<mail_record_list :course_type="course_type" :course_id="course_id_id" @guanbi="course_id_id=0"></mail_record_list>
		<!-- 备注 -->
		<el-dialog :title="$t('feedback_index.remarks')" width="800px" :close-on-click-modal="false" :visible="editFormVisible_1" @close="editFormVisible_1 = false">
			<el-form :model="editForm_1" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm_1">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item :label="$t('feedback_index.remarks')" prop="remarks">
							<el-input v-model="editForm_1.remarks" type="textarea" :autosize="{ minRows: 4, maxRows: 6}" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click.native="editFormVisible_1 = false">{{$t('index.cancel')}}</el-button>
				<el-button size="mini" type="primary" @click.native="editSubmit1('editForm_1')">{{$t('index.submit')}}</el-button>
			</div>
		</el-dialog>
		<!-- 操作记录 -->
		<operation_records table="course" :pk_id="pk_id" @callback="()=>{is_operation_records=!is_operation_records}" :is_operation_records="is_operation_records"></operation_records>
	</div>
</template>
<script>
// import EditorBar from '@/components/wangEnduit.vue'
import teacher_student_list from '@/components/teacher_student_list.vue'
import mail_record_list from '@/components/mail_record_list.vue'
import operation_records from './components/operation_records.vue'
import courseRemoteList from '@/components/courseRemoteList.vue'
export default {
	computed: {
		props(){
			return{
				value: 'id',
				label: this.lang=='cn'?'name_cn':'name',
			}
		},
		props_(){
			return{
				checkStrictly: true,
				value: 'id',
				label: this.lang=='cn'?'name_cn':'name',
			}
		},
		editFormRules(){
			return{
				price: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.price'),
					trigger: 'blur'
				}],
				min_age: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.min_age'),
					trigger: 'blur'
				}],
				max_age: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.max_age'),
					trigger: 'blur'
				}],
				max_people: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.max_people'),
					trigger: 'blur'
				}],
				session: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.session'),
					trigger: 'change'
				}],
				week: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.week'),
					trigger: 'change'
				}],
				cate: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.cate'),
					trigger: 'change'
				}],
				teacher_id: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.teacher'),
					trigger: 'change'
				}],
				center_id: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.center'),
					trigger: 'change'
				}],
				date: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.date'),
					trigger: 'change'
				}],
				time: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.time'),
					trigger: 'change'
				}],
				title: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.youjian_title'),
					trigger: 'blur'
				}],
				tmp_id: [{
					required: true,
					message: this.$t('index.select')+this.$t('course_index.xuanzyoujian'),
					trigger: 'change'
				}],

				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('course_index.field_name'),
					trigger: 'blur'
				}],
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('course_index.field_name'),
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('course_index.field'),
					trigger: 'blur'
				},{
					pattern: /^[a-zA-Z_][a-zA-Z0-9_]+$/,
					message: this.$t('course_index.code'),
					trigger: ['blur', 'change']
				}],
			}
		},
	},
	components: {
		// EditorBar,
		teacher_student_list,
		mail_record_list,
		courseRemoteList,
		operation_records
	},
	data() {
		return {
			loading:null,
			this_:this,
			isClear:false,
			is_co:sessionStorage.getItem('is_co'),
			pages: {
			},
			list: [],
			editForm: {},
			editFormVisible: false,
			pages: {
				age:'',
				teacher_id:'',
				session:'',
				center_id:'',
				week:'',
				keyword:'',
				id:'',
				cate:[],
				date:[],
				sort_filed:'',
				sort_type:'',
				page: 1,
				count: 0,
				perpage: 10,
				shiting:0
			},
			WEEK_ARR: [],
			DATA_RIGHTS: [],
			STATUS: [],
			SESSION_ARR: [],
			cateOption: [],
			API_URL:process.env.API_URL,
			API_UP:process.env.API_UP,
			TokenId:sessionStorage.getItem('TokenId'),
			isdialog:false,
			teacher_course_index_id:0,
			age:[],
			class_date:[],
			learnCenter:[],
			session_list:[],
			teacher:[],
			sellerList:[],
			courseSellerList:[],
			xuanzyoujian_is:false,
			course_id:'',
			form:{
				is_notice:true,
				title:'',
				content:'',
				tmp_id:'',
				mail_type:1,
				seller_id:[],
				child_ids:[],
			},
			tmplist:[],
			seller_id_is:false,
			course_id_array:[],

			student_list:[], //学生列表
			mail_type_list:[
				{
					id:1,
					cn:'全部发送',
					en:'Send all',
				},
				{
					id:2,
					cn:'部分发送',
					en:'Send Partial',
				}
			],
			course_type:'course',
			course_id_id:0,
			editForm_1:{
				id:'',
				remarks:'',
			},
			editFormVisible_1:false,
			loadingInstance:null,
			pk_id:0,
			is_operation_records:false,
			is_other_course:false,
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			this.$post('getDictionaryValue',{code:'WEEK_ARR,SESSION_ARR,STATUS'}).then((res) => {
				this.WEEK_ARR = res.WEEK_ARR;
				this.SESSION_ARR = res.SESSION_ARR;
				this.STATUS = res.STATUS;
			})
			this.$post('cateOption', {type:'1'}).then((res) => {
				this.cateOption=this.xunhaun(res.show);
			})
			this.$post('courseScreen', {}).then((res) => {
				this.age=res.age;
				this.class_date=res.class_date;
				this.learnCenter=res.learnCenter;
				this.session_list=res.session_list;
				this.teacher=res.teacher;
				this.sellerList=res.sellerList;
				this.courseSellerList=res.courseSellerList;
			})
			this.$post('emailTmpList', {type:'class_starts'}).then((res) => {
				this.tmplist=res;
			})
			// this.$post('courseRemoteList', {}).then((res) => {})
		},
		// 初始化
		init: function () {
			var this_ = this;
			var url = "courseIndex"
			var datas = {
				...this.pages,
				num: this.pages.perpage,
				is_hide:1
			}
			if (this.pages.cate&&this.pages.cate.length>0) {
				datas['cate_id']=this.pages.cate[0];
				datas['cate_node_id']=this.pages.cate[1]||'';
				datas['cate_three_id']=this.pages.cate[2]||'';
				datas['cate_four_id']=this.pages.cate[3]||'';
			}
			if (this.pages.date&&this.pages.date.length>0) {
				datas['start_date']=this.pages.date[0]/1000;
				var time=(24*60*60-1)*1000;
				datas['end_date']=(this.pages.date[1]+time)/1000;
			}else if(this.pages.year){
				var start_date = Math.round(new Date(this.pages.year,0,1,0,0,0).getTime()/1000);
				var end_date = Math.round(new Date(this.pages.year,11,31,23,59,59).getTime()/1000);
				datas['start_date']=start_date;
				datas['end_date']=end_date;
				delete datas.year;
			}
			this.$post(url, datas).then((res) => {
				this.list = res.list;
				this.pages.count = res.sum;
			})
		},
		// 搜索
		search() {
			this.pages.page = 1;
			this.init();
		},
		// 重置
		reset() {
			this.pages = this.$options.data().pages;
			this.init();
		},
		// 排序
		sort_change(data){
			this.pages.sort_filed=data.prop;
			if (data.order=="ascending") {
				this.pages.sort_type='desc';
			}else if(data.order=="descending"){
				this.pages.sort_type='asc';
			}else {
				this.pages.sort_type='';
			}
			this.init();
		},
		handleCommand(e,data){
			switch(e){
				case 'a':
					this.courseHide(data);
				break
				case 'b':
					this.del(data);
				break
				case 'c':
					this.teacher_course_index_id=data.id;
					this.isdialog=true
				break
				case 'd':
					this.router_url('/teacher_course_arrange',{id:data.id});
				break
				case 'e':
					this.kaike(data);
				break
				case 'f':
					this.course_id_id=data.id;
				break
				case 'j':
					this.router_url('/virtual_index',{id:data.id,course_type:'course'});
				break
				case 'h':
					this.remarks_ff(data);
				break
				case 'r':
					this.pk_id = data.id
					this.is_operation_records = true;
				break
				case 'i':
					this.copy(data,true);
				break
			}
		},
		add(data,copy) {
			if (data) {
				var this_ = this;
				var url = "courseInfo"
				var datas = {
					id: data.id,
				}
				this_.$post(url, datas).then((res) => {
					var data_data=JSON.parse(JSON.stringify(res));
					var editForm = data_data;
					var date = [];
					date[0] = data_data.start_date?data_data.start_date* 1000:'';
					date[1] = data_data.end_date?data_data.end_date* 1000:'';
					editForm['date'] = date;
					if (data_data.start_time&&data_data.end_time) {
						var time = [];
						time[0] = data_data.start_time?data_data.start_time* 1000:'';
						time[1] = data_data.end_time?data_data.end_time* 1000:'';
					}else{
						var time = null;
					}
					editForm['time'] = time;
					// var early_time = [];
					// if (data_data.early_start_time&&data_data.early_end_time) {
					// 	early_time[0] = data_data.early_start_time?data_data.early_start_time* 1000:'';
					// 	early_time[1] = data_data.early_end_time?data_data.early_end_time* 1000:'';
					// }
					// editForm['early_time'] = early_time;
					var cate = [];
					if (data_data.cate_id) {
						cate[0]=data_data.cate_id;
						if (data_data.cate_node_id) {
							cate[1]=data_data.cate_node_id;
							if (data_data.cate_three_id) {
								cate[2]=data_data.cate_three_id;
								if (data_data.cate_four_id) {
									cate[3]=data_data.cate_four_id;
								}
							}
						}
					}
					editForm['cate'] = cate;
					var week=[];
					if (data_data.week) {
						week=data_data.week.split(',');
					}
					editForm['week'] = week;
					var no_course_dates = [];
					if (data_data.no_course_dates) {
						no_course_dates = data_data.no_course_dates.split(',');
						no_course_dates.forEach(function(e, i) {
							var date=new Date(new Date(e*1000).setHours(0,0,0,0)).getTime();
							no_course_dates[i]=date;
						});
					}
					editForm['no_course_dates'] = no_course_dates;
					var have_date_time=[];
					if (data_data.have_date_time) {
						have_date_time=data_data.have_date_time.split(',');
					}
					editForm['have_date_time'] = have_date_time;
					// var teacher_id=[];
					// if (data_data.teacher_id) {
					// 	teacher_id=String(data_data.teacher_id).split(',');
					// }
					// editForm['teacher_id'] = teacher_id;
					var seller_id=[];
					if (data_data.seller_id) {
						seller_id=String(data_data.seller_id).split(',');
					}
					editForm['seller_id'] = seller_id;
					if (copy) {
						editForm['theme'] = data_data.theme+'-copy';
						editForm['is_up'] = 0;
						editForm['theme_cn'] = data_data.theme_cn+'-复制';
						editForm['id'] = '';
						var course_field=data_data.course_field;
						for(var i = 0, length1 = course_field.length; i < length1; i++){
							course_field[i]['id']='';
						}
						editForm['course_field'] = course_field;
					}
					this_.editForm = editForm;
					if (copy) {
						this_.tijiao();
						// this_.editFormVisible = true;
					}else{
						if (this_.$refs.editForm) {
							this_.$refs.editForm.resetFields();
						}
						this_.editFormVisible = true;
					}
				})
			} else {
				this.editForm = {
					cate_id: '',
					cate_node_id: '',
					cate_three_id: '',
					cate_four_id: '',
					price: '',
					teacher_id: '',
					assistant_id: '',
					min_age: '',
					max_age: '',
					start_date: '',
					end_date: '',
					no_course_dates: [],
					week:[],
					start_time: '',
					end_time: '',
					center_id: '',
					session: '',
					theme: '',
					theme_cn: '',
					max_people: '',
					// country: '',
					power_type: 'public',
					password: '',
					content_cn: '',
					class_num: '',
					content: '',
					// early_discount: '',
					introduce: '',
					introduce_cn: '',
					zoom: '',
					seller_id:[],
					course_seller_id:'',
					date: [],
					time: null,
					is_show_contact: 0,
					is_show_evaluation: 0,
					noon_price: 0,
					audition_price:0,
					is_show_front: 0,
					course_field:[],
					remote_course_id:'',
					send_leave_coupon:1,
				}
				if (this.$refs.editForm) {
					this.$refs.editForm.resetFields();
				}
				this.editFormVisible = true;
			}
		},
		// 开课
		kaike(data){
			var this_ = this;
			this_.$confirm(this_.$t('index.confirm_kaike'), this_.$t('index.tips')).then(() => {
				// 获取学生列表
				var url = "courseClasses"
				var datas = {
					course_id: data.id,
				}
				this_.$post(url, datas).then((res) => {
					this_.editForm=JSON.parse(JSON.stringify(data));
					this_.course_id=data.id;
					this_.xuanzyoujian_is=true;
					this_.form = this_.$options.data().form;
					this_.student_list=res.student;
				})
			}).catch(() => {})
		},
		// 选择邮件模板后显示邮件内容
		tmp_id_f(){
			var this_ = this;
			var tmplist=this_.tmplist;
			var tmp_id=this_.form.tmp_id;
			tmplist.forEach(function(e,i) {
				if (e.id==tmp_id) {
					this_.form.content=JSON.parse(JSON.stringify(e.content));
				}
			});
		},
		// 点击开课后弹出提示后的确认
		xuanzyoujian_f(){
			var this_ = this;
			this_.$refs.form.validate((valid) => {
				if (valid) {
					var url = "openCourse"
					var datas = {
						course_id: this_.course_id,
						type:'course',
					}
					this_.$post(url, datas).then((res) => {
						if (this_.form.is_notice) {
							this_.youjian();
						}else{
							this_.$message.success(this_.$t('index.operation_success'));
							this_.xuanzyoujian_is=false;
							this_.init();
						}
					})
				}
			})
		},
		// 发送邮件
		youjian(){
			var this_ = this;
			var url="openCourseSendEmail";
			var datas={
				course_id:this_.course_id,
				course_type:'course',
				title:this_.form.title,
				content:this_.form.content,
				child_ids:'',
			}
			if (this_.form.mail_type==2) {
				datas.child_ids=this_.form.child_ids.join(',');
			}
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.xuanzyoujian_is=false;
				this_.init();
			})
		},
		copy(data){
			var this_ = this;
			var url = "courseInfo"
			var datas = {
				id: data.id,
			}
			this_.loadingInstance = this_.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)',
				customClass: 'loading_mask',
			});
			this_.$post(url, datas,false).then((res) => {
				var data_data=JSON.parse(JSON.stringify(res));
				var editForm = data_data;
				if (!data_data.no_course_dates) {
					editForm['no_course_dates'] = '';
				}
				editForm['theme'] = data_data.theme+'-copy';
				editForm['is_up'] = 0;
				editForm['status'] = 1;
				editForm['theme_cn'] = data_data.theme_cn+'-复制';
				editForm['id'] = '';
				var course_field=data_data.course_field;
				for(var i = 0, length1 = course_field.length; i < length1; i++){
					course_field[i]['id']='';
				}
				var datas = {
					...editForm,
					country:'us',
					course_field:JSON.stringify(course_field),
				}
				var url = "courseAction";
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.add_success'));
					this_.editFormVisible = false;
					this_.init();
					this_.loadingInstance.close();
					this_.loadingInstance = null;
				});
			})
		},
		tijiao(){
			var this_ = this;
			var url = "courseAction";
			var datas = {
				price: this_.editForm.price,
				min_age: this_.editForm.min_age,
				teacher_id: this_.editForm.teacher_id,
				assistant_id: this_.editForm.assistant_id,
				max_age: this_.editForm.max_age,
				center_id: this_.editForm.center_id,
				session: this_.editForm.session,
				theme: this_.editForm.theme,
				theme_cn: this_.editForm.theme_cn,
				max_people: this_.editForm.max_people,
				country:'us',
				power_type: this_.editForm.power_type,
				password: this_.editForm.password,
				content: this_.editForm.content,
				content_cn: this_.editForm.content_cn,
				class_num: this_.editForm.class_num,
				// early_discount: this_.editForm.early_discount,
				introduce: this_.editForm.introduce,
				introduce_cn: this_.editForm.introduce_cn,
				zoom: this_.editForm.zoom,
				seller_id: this_.editForm.seller_id,
				course_seller_id: this_.editForm.course_seller_id,
				is_show_contact: this_.editForm.is_show_contact,
				is_show_evaluation: this_.editForm.is_show_evaluation,
				is_show_front: this_.editForm.is_show_front,
				// have_date_time: this_.editForm.have_date_time.join(','),
				no_course_dates:this_.editForm.no_course_dates,
				noon_price:this_.editForm.noon_price,
				audition_price:this_.editForm.audition_price,
				remote_course_id:this_.editForm.remote_course_id,
				send_leave_coupon:this_.editForm.send_leave_coupon,
			}
			// 星期
			if (this_.editForm.week&&this_.editForm.week.length>0) {
				datas['week']=this_.editForm.week.join(',');
			}
			// 老师
			// if (this_.editForm.teacher_id&&this_.editForm.teacher_id.length>0) {
			// 	datas['teacher_id']=this_.editForm.teacher_id.join(',');
			// }
			// 管理员
			if (this_.editForm.seller_id&&this_.editForm.seller_id.length>0) {
				datas['seller_id']= this_.editForm.seller_id.join(',');
			}
			// 分类
			if (this_.editForm.cate.length>0) {
				datas['cate_id']= this_.editForm.cate[0]||'';
				datas['cate_node_id']= this_.editForm.cate[1]||'';
				datas['cate_three_id']= this_.editForm.cate[2]||'';
				datas['cate_four_id']= this_.editForm.cate[3]||'';
			}
			// 日期
			if (this_.editForm.date.length) {
				datas['start_date']= this_.shijian(this_.editForm,'start_date');
				datas['end_date']=this_.shijian(this_.editForm,'end_date');
			}
			// 时间
			if (this_.editForm.time.length) {
				datas['start_time']= this_.shijian(this_.editForm,'start_time');
				datas['end_time']= this_.shijian(this_.editForm,'end_time');
			}
			// 早鸟时间
			// if (this_.editForm.early_time&&this_.editForm.early_time.length) {
			// 	datas['early_start_time']= this_.editForm.early_time[0]/1000||'';
			// 	datas['early_end_time']= this_.editForm.early_time[1]/1000||'';
			// }else{
			// 	datas['early_start_time']='';
			// 	datas['early_end_time']='';
			// }
			// 不上课日期
			if (this_.editForm.no_course_dates&&this_.editForm.no_course_dates.length>0) {
				datas['no_course_dates']=this_.no_course_dates_ff(datas);
			}
			// 上课时间
			datas['have_date_time']=this_.have_date_time_f(datas);
			if(this_.editForm.course_field.length){
				datas['course_field']=JSON.stringify(this_.editForm.course_field);
			}else{
				datas['course_field']='';
			}
			var tishi = this_.$t('index.add_success');
			if (this_.editForm.id) {
				datas['id'] = this_.editForm.id;
				tishi = this_.$t('index.modify_success');
			}
			this_.$post(url, datas).then((res) => {
				this_.$message.success(tishi);
				this_.editFormVisible = false;
				this_.init();
			});
		},
		// 点击保存按键
		editSubmit() {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					this_.tijiao();
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "courseDelete";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 隐藏
		courseHide(data) {
			var this_ = this;
			var url = "courseHide";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_hide'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 上下线
		up(data,value){
			var this_ = this;
			var url = "changeField";
			var datas = {
				pk_id: data.id,
				table:'course',
				field:'is_up',
				value:value,
			};
			this_.$post(url, datas).then((res) => {
				this_.$message.success(this_.$t('index.operation_success'));
				this_.init();
			})
		},
		// 表格多选的回调
		handleSelectionChange(data){
			var course_id_array=[];
			data.forEach(function(e,i) {
				course_id_array[i]=e.id;
			});
			this.course_id_array=course_id_array;
		},
		// 弹出选择管理员
		seller_id_ff(){
			var this_ = this;
			if (this_.course_id_array.length==0) {
				this_.$message.success(this_.$t('index.please_check'));
			}else{
				this_.seller_id_is=true;
			}
		},
		// 批量绑定管理员
		seller_id_f(){
			var this_ = this;
			this_.$refs.form.validate((valid) => {
				if (valid) {
					var url = "addClassDirectorApi"
					var datas = {
						course_id: this_.course_id_array.join(','),
						seller_id: this_.form.seller_id.join(','),
						course_type:'course',
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.modify_success'));
						this_.seller_id_is = false;
						this_.init();
					})
				}
			})
		},
		// 根据日期区间计算课次
		class_num_f(data){
			var this_ = this;
			var editForm=this_.editForm;
			var week=editForm.week||[];
			if (typeof editForm.week == 'string') {
				week=editForm.week?editForm.week.split(','):[];
			}
			var date=editForm.date;
			var time=editForm.time;
			var no_course_dates=editForm.no_course_dates||[];
			if (typeof editForm.no_course_dates == 'string') {
				no_course_dates=editForm.no_course_dates?editForm.no_course_dates.split(','):[];
			}
			if (week&&week.length>0&&date&&date.length>0&&time&&time.length>0) {
				var datas={};
				datas['week']=week;
				datas['start_date']= this_.shijian(editForm,'start_date');
				datas['end_date']=this_.shijian(editForm,'end_date');
				datas['start_time']= this_.shijian(editForm,'start_time');
				datas['end_time']= this_.shijian(editForm,'end_time');
				var start_time=datas.start_time*1000;
				var no_course_dates_array=[];
				no_course_dates.forEach(function(e,ii) {
				    var y=this_.getti(e,'y');
				    var m=this_.getti(e,'m');
				    var d=this_.getti(e,'d');
				    var h=this_.getti(start_time,'h');
				    var i=this_.getti(start_time,'i');
				    var s=this_.getti(start_time,'s');
					no_course_dates_array[ii] = Math.round(new Date(y,m,d,h,i,s).getTime()/1000);
				});
				datas['no_course_dates']=no_course_dates_array;
				var have_date_time=this_.have_date_time_f(datas);
				if (have_date_time) {
					this_.editForm.class_num=have_date_time.split(',').length;
				}else{
					this_.editForm.class_num=0;
				}
			}
		},
		/* 获取时间段内属于星期一(*)的日期们
		 * begin: 开始时间
		 * end：结束时间
		 * weekNum：星期几 {number}
		 */
		getWeek (unixDb, unixDe, weekNum){
			var this_ = this;
			var dateArr = new Array();
			for (var k = unixDb; k <= unixDe;) {
				var Day=new Date(k).getDay();
				if (weekNum.indexOf(String(Day))!=-1) {
					dateArr.push(k);
				}
				var dateTime=new Date(k);
				dateTime.setDate(dateTime.getDate()+1);
				dateTime=new Date(dateTime).getTime();
				k = dateTime;
			}

			return dateArr;
		},
		// 设置开始结束时间
		shijian(data,quj){
			if(data.date){
			    var start_date=data.date[0];
			    var end_date=data.date[1];
			}else{
			    var start_date=data.start_date*1000;
			    var end_date=data.end_date*1000;
			}
			if (data.time) {
			    var start_time=data.time[0];
			    var end_time=data.time[1];
			}else{
			    var start_time=data.start_time*1000;
			    var end_time=data.end_time*1000;
			}
			if (quj=='start_date') {
			    var y=this.getti(start_date,'y');
			    var m=this.getti(start_date,'m');
			    var d=this.getti(start_date,'d');
			    var h=this.getti(start_time,'h');
			    var i=this.getti(start_time,'i');
			    var s=this.getti(start_time,'s');
			}else if(quj=='end_date'){
			    var y=this.getti(end_date,'y');
			    var m=this.getti(end_date,'m');
			    var d=this.getti(end_date,'d');
			    var h=this.getti(end_time,'h');
			    var i=this.getti(end_time,'i');
			    var s=this.getti(end_time,'s');
			}else if(quj=='start_time'){
			    var y=this.getti(start_date,'y');
			    var m=this.getti(start_date,'m');
			    var d=this.getti(start_date,'d');
			    var h=this.getti(start_time,'h');
			    var i=this.getti(start_time,'i');
			    var s=this.getti(start_time,'s');
			}else if(quj=='end_time'){
			    var y=this.getti(start_date,'y');
			    var m=this.getti(start_date,'m');
			    var d=this.getti(start_date,'d');
			    var h=this.getti(end_time,'h');
			    var i=this.getti(end_time,'i');
			    var s=this.getti(end_time,'s');
			}
			let datetime = Math.round(new Date(y,m,d,h,i,s).getTime()/1000);
			return datetime
		},
		// 不上课时间格式
		no_course_dates_ff(data){
			var this_ = this;
			if (data.no_course_dates) {
				var no_course_dates=data.no_course_dates;
				if (typeof data.no_course_dates == 'string') {
					no_course_dates=data.no_course_dates?data.no_course_dates.split(','):[];
				}
				var start_time=data.start_time*1000;
				var no_course_dates_array=[];
				no_course_dates.forEach(function(e,ii) {
				    var y=this_.getti(e,'y');
				    var m=this_.getti(e,'m');
				    var d=this_.getti(e,'d');
				    var h=this_.getti(start_time,'h');
				    var i=this_.getti(start_time,'i');
				    var s=this_.getti(start_time,'s');
					no_course_dates_array[ii] = Math.round(new Date(y,m,d,h,i,s).getTime()/1000);
				});
				return no_course_dates_array.join(',');
			}else{
				return '';
			}
		},
		getti(data,ss){
			let datetime = new Date(data);
		    let year = datetime.getFullYear();
		    let month = datetime.getMonth();
		    let date = datetime.getDate();
		    let hour = datetime.getHours();
		    let minute = datetime.getMinutes();
		    let second = datetime.getSeconds();
		    if (ss=='y') {
		    	return year
		    }else if(ss=='m'){
		    	return month
		    }else if(ss=='d'){
		    	return date
		    }else if(ss=='h'){
		    	return hour
		    }else if(ss=='i'){
		    	return minute
		    }else if(ss=='s'){
		    	return second
		    }
		},
		// 分类显示文字
		cate_id_f(w, s, d){
			var this_=this;
			var id = w.cate_id;
			var id_id = w.cate_node_id;
			var id_id_id = w.cate_three_id;
			var id_id_id_id = w.cate_four_id;
			var cate='';
			var lang_is=this_.lang=='cn'
			var cateOption=this_.cateOption;
			this_.cateOption.forEach(function(e,i) {
				if (e.id== w.cate_id) {
					cate=lang_is?e.name_cn:e.name;
					e.children&&e.children.forEach(function(ee,ii) {
						if (ee.id==id_id) {
							cate+='/'+(lang_is?ee.name_cn:ee.name);
							ee.children&&ee.children.forEach(function(eee, iii) {
								if (eee.id==id_id_id) {
									cate+='/'+(lang_is?eee.name_cn:eee.name);
									eee.children&&eee.children.forEach(function(eeee, iiii) {
										if (eeee.id==id_id_id_id) {
											cate+='/'+(lang_is?eeee.name_cn:eeee.name);
										}
									});
								}
							});
						}
					});
				}
			});
			return cate
		},
		// 计算上课日期
		have_date_time_f(data){
			var this_ = this;
			var start_date=data.start_date;
			var end_date=data.end_date;
			var start_time=data.start_time;
			var week=data.week;
			var no_course_dates=data.no_course_dates||[];
			var class_num_array=this_.getWeek(start_date*1000,end_date*1000,week);
			var class_num_array_new=[];
			var iii=0;
			class_num_array.forEach(function(e,i) {
				var zhi=Math.round(e/1000);
				if (no_course_dates.indexOf(zhi)==-1) {
					class_num_array_new[iii]=e;
					iii++;
				}
			});
			return class_num_array_new.length>0?class_num_array_new.join(','):'';
		},
		// 单独写的更新课次
		// class_num_ff(data){
		// 	var this_ = this;
		// 	var editForm=data;
		// 	var week=editForm.week||[];
		// 	if (typeof editForm.week == 'string') {
		// 		week=editForm.week?editForm.week.split(','):[];
		// 	}
		// 	var start_date=editForm.start_date;
		// 	var end_date=editForm.end_date;
		// 	var no_course_dates=editForm.no_course_dates?editForm.no_course_dates.split(','):[];
		// 	if (week&&start_date&&end_date) {
		// 		var class_num_array=this_.getWeek(start_date*1000,end_date*1000,week);
		// 		var class_num=class_num_array.length-no_course_dates.length;
		// 		data.class_num=class_num;
		// 		data.have_date_time=class_num_array;
		// 		this_.keci(data);
		// 	}
		// },
		// keci(data){
		// 	var this_ = this;
		// 	var url = "changeField";
		// 	var datas = {
		// 		table:'course',
		// 		field:'have_date_time',
		// 		value: data.have_date_time,
		// 		pk_id: data.id,
		// 	}
		// 	this_.$post(url, datas).then((res) => {
		// 		console.log(1)
		// 	});
		// },
		// ceshi(){
		// 	var this_ = this;
		// 	var list=this_.list;
		// 	list.forEach(function(e,i) {
		// 		if (e.status>1) {
		// 			var url = "openCourse"
		// 			var datas = {
		// 				course_id: e.id,
		// 				type:'course',
		// 			}
		// 			this_.$post(url, datas).then((res) => {
		// 				// this_.youjian();
		// 			})
					
		// 		}
		// 	});
		// },
		have_date_time_ff(data){
			var this_ = this;
			var start_date=data.start_date;
			var end_date=data.end_date;
			var start_time=data.start_time;
			var week=data.week;
			var no_course_dates=data.no_course_dates;
			var class_num_array=this_.getWeek(start_date*1000,end_date*1000,week);
			class_num_array.forEach(function(e,i) {
				var zhi=Math.round(e/1000);
				if (no_course_dates.indexOf(zhi)!=-1) {
					this_.removeByIndex(class_num_array,i)
				}
			});
			return class_num_array.length>0?class_num_array.join(','):'';
		},

		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		imageSuccess(res, file,name){
			if (res.status == 200) {
				this.$message.success(res.message);
				this.reset();
			} else {
				this.$message.error(res.message);
			}
	        if (this.loading) {
		        this.loading.close();
			}
		},
		remarks_ff(data){
			this.editForm_1.id=data.id;
			this.editForm_1.remarks=data.remarks;
			this.editFormVisible_1=true;
		},
		editSubmit1(editForm){
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var datas = {
						table: 'course',
						field: 'remarks',
						value: this_.editForm_1.remarks,
						pk_id: this_.editForm_1.id,
					}
					var url = "changeField";
					this_.$post(url, datas).then((res) => {
						this_.$message.success(this_.$t('index.add_success'));
						this_.editFormVisible_1 = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		field_add(){
			var obj={
				code:'',
				name:'',
				name_cn:'',
				is_must:0,
			}
			this.editForm.course_field.push(obj);
		},
		field_del(index){
			this.removeByIndex(this.editForm.course_field,index);
		},
		importtemplate(){
			var url =  process.env.API_ROOT+'../upload/download/tmp_course.xls';
			console.log(url)
			window.open(url);
		},
		filters_list(value,list,id,name){
			for (var i = list.length - 1; i >= 0; i--) {
				if(list[i][id]==value){
					return this.lang=="cn"?list[i][name+'_cn']:list[i][name];
				}
			}
		},
		filters_cate(data){
			var cate='';
			var lang_is=this.lang=='cn'
			var cateOption=this.cateOption;
			cateOption.forEach(function(e,i) {
				if (e.id == data.cate_id) {
					cate = lang_is?e.name_cn:e.name;
					e.children&&e.children.forEach(function(ee,ii) {
						if (ee.id == data.cate_node_id) {
							cate += '/'+(lang_is?ee.name_cn:ee.name);
							ee.children&&ee.children.forEach(function(eee, iii) {
								if (eee.id == data.cate_three_id) {
									cate += '/'+(lang_is?eee.name_cn:eee.name);
									eee.children&&eee.children.forEach(function(eeee, iiii) {
										if (eeee.id == data.cate_four_id) {
											cate += '/'+(lang_is?eeee.name_cn:eeee.name);
										}
									});
								}
							});
						}
					});
				}
			});
			return cate
		}
	},
	// 过滤器
	filters: {
		session_ff(v,this_){
			var list=this_.SESSION_ARR;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.code==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},
		teacher_f(v,this_){
			var list=this_.teacher;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.teacher_id==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},
		center_f(v,this_){
			var list=this_.learnCenter;
			var fanhuizhi="";
			list.forEach(function(e, i) {
				if (e.id==v) {
					fanhuizhi=this_.lang=="cn"?e.name_cn:e.name;
				}
			});
			return fanhuizhi
		},
	}
}
</script>
<style scoped>
.matop{
	margin-top: 10px;
}
.clo3{
	color: #ff0000;
}
.filter-inline-panel {
	margin-bottom: 18px;
}
.filter-panel {
	display: inline-block;
	width:calc( 100% - 240px );
	vertical-align: top;
}
.filter-panel.on{
	width:calc( 100% - 300px );
}
.dialog-header{
	text-align: right;
	padding-bottom: 20px;
}
.line{
	text-align: center;
}
.el-date-editor.w100{
	width: 100%;
}

.upload_{
	display: inline-block;
	margin-left: 10px;
}
.fint {
	font-size: 28px;
	margin-top: 30px;
	cursor: pointer;
}
</style>
<style type="text/css">
textarea{
	font-family: inherit;
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/course_index.vue